import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
interface UnlockedBannerProps {
  show: boolean;
  onDismiss: () => void;
}
export function UnlockedBanner({
  show,
  onDismiss
}: UnlockedBannerProps) {
  return <AnimatePresence data-id="element-437" data-mp="1vvbf98yfy2i8">
      {show && <motion.div role="status" initial={{
      opacity: 0,
      y: -8
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -8
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="flex items-start gap-3 rounded-xl border border-emerald-400/25 bg-forensic-surface p-4 sm:items-center" data-id="element-438" data-mp="20o4p2b8ro116">
          <CheckCircle2 size={20} className="shrink-0 text-emerald-400" aria-hidden="true" data-id="element-439" data-mp="2jmqqjr873u5m" />
          <div className="flex-1" data-id="element-440" data-mp="l746mxpyjmk9">
            <p className="text-sm font-semibold text-white" data-id="element-441" data-mp="l85ts0k8zzic">Forensic report unlocked</p>
            <p className="mt-0.5 text-sm text-forensic-muted" data-id="element-442" data-mp="p869rpmzwiri">
              Evidence, detailed analysis, recommendations, and your PDF are now available below.
            </p>
          </div>
          <button type="button" onClick={onDismiss} aria-label="Dismiss" className="rounded-lg p-1.5 text-forensic-subtle transition-colors duration-150 ease-out hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400" data-id="element-443" data-mp="1qrvn6g3u2wfm">
            <X size={16} data-id="element-444" data-mp="2ei9j4hpjhffh" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}